import * as React from "react";
import type { SVGProps } from "react";
const SvgPadIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="pad_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M512 853.333A42.667 42.667 0 1 1 512 768a42.667 42.667 0 0 1 0 85.333zM256 42.71A170.667 170.667 0 0 0 85.333 213.376v597.333A170.667 170.667 0 0 0 256 981.376h512a170.667 170.667 0 0 0 170.667-170.667V213.376A170.667 170.667 0 0 0 768 42.709H256zm-85.333 170.667A85.333 85.333 0 0 1 256 128.043h512a85.333 85.333 0 0 1 85.333 85.333v597.333A85.333 85.333 0 0 1 768 896.043H256a85.333 85.333 0 0 1-85.333-85.334V213.376z"
    />
  </svg>
);
export default SvgPadIcon;
